import { PayloadAction } from '@reduxjs/toolkit';

import { DesignState } from 'editor/src/store/design/types';

const setAutoApplyPublicHolidaysFlagReducer = (state: DesignState, action: PayloadAction<boolean>) => {
  if (!state.designData) {
    return;
  }

  if (!state.designData.calendar) {
    state.designData.calendar = {};
  }

  state.designData.calendar.autoApplyPublicHolidays = action.payload;
};

export default setAutoApplyPublicHolidaysFlagReducer;
